import { useSelector } from 'react-redux';

export function useIsAppMinimized() {
    return useSelector((state) => !state.ui.sidePanel.maximize);
}
